module.exports = __webpack_public_path__ + "static/agree-959bb5a35ec96b4806089e9c8081a880.mp3";